<template>
  <div class="content">
    <div class="detail_title">{{ title || $t("detail") }}</div>
    <Row v-for="(item, i) in info" :key="'detail' + i" class="item">
      <Col span="6" class="label">{{ item.label }}</Col>
      <Col span="6" class="value" v-if="!item.slot_tree">
        <!-- 如果插槽 显示插槽 --- 非插槽显示对应的 formType 组件 默认span标签 -->
        <span v-if="!item.slot">
          <Input
            v-if="item.formType == 'input'"
            v-model="item.value"
            placeholder="—"
            class="input"
          />
          <DatePicker
            v-else-if="item.formType == 'date'"
            v-model="item.value"
            @on-change="newVal => handleDateChange(newVal, item, 'value')"
            type="date"
            placeholder="-"
          ></DatePicker>
          <span v-else class="value_span">{{ item.value }}</span>
        </span>
        <slot v-else :name="item.slot" :data="item"></slot>
      </Col>

      <Col span="6" offset="1" class="value_two" v-if="!item.slot_tree">
        <span v-if="!item.slot_two">
          <Input
            v-if="item.formType_two == 'input'"
            v-model="item.value_two"
            placeholder="—"
            class="input"
          />
          <DatePicker
            v-else-if="item.formType_two == 'date'"
            v-model="item.value_two"
            @on-change="newVal =>handleDateChange(newVal, item, 'value_two')"
            type="date"
            placeholder="-"
          ></DatePicker>
          <span v-else class="value_span">{{ item.value_two }}</span>
        </span>
        <slot v-else :name="item.slot_two" :data="item"></slot>
      </Col>
      <Col v-else span="17" class="value">
        <slot :name="item.slot_tree" :data="item"></slot>
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {
    info: Array,
    title: String
  },
  data () {
    return {};
  },
  methods: {
    handleDateChange: function (newVal, item, key) {
      item[key] = newVal;
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  border: 1px solid #ddd;
}
.detail_title {
  font-size: 18px;
  padding: 10px 20px;
  font-weight: 600;
}
.item {
  padding: 10px 20px;
  display: flex;
  border-top: 1px solid #ddd;
}
.item2 {
  width: 100%;
  display: flex;
}
.label {
  font-size: 14px;
  display: flex;
  align-items: center;
}
.value {
  font-size: 14px;
}
.value_span {
  padding-left: 7px;
  display: flow-root;
}
.value_two {
  font-size: 14px;
}
/deep/ .ivu-input,
.ivu-select-selection {
  background-color: #fff;
  color: #000;
  font-size: 14px;
  border: 0;
}
/deep/ .ivu-date-picker .ivu-input-suffix {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/myDetailCell.vue